import {
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material'
import { useAtomValue, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { currentMappingSetAtom } from './atoms'
import { useAllCrosswalks } from 'domains/scope-and-sequence/hooks'
import { CrosswalkMappingSetType } from 'domains/scope-and-sequence/types'

export function CrosswalkSelector() {
  const allCrosswalks = useAllCrosswalks()
  const currentMappingSet = useAtomValue(currentMappingSetAtom)
  const setCurrentMappingSet = useSetAtom(currentMappingSetAtom)

  const handleChange = (id: number | '') => {
    if (id === '') {
      setCurrentMappingSet(undefined)
      return
    }
    const selected = allCrosswalks?.find(
      (c: CrosswalkMappingSetType) => c.id === id,
    )
    setCurrentMappingSet(selected)
  }

  return (
    <Card variant="outlined" sx={{ borderRadius: 2, backgroundColor: '#fff' }}>
      <CardContent>
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Crosswalk Mapping Set
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Select a crosswalk to include with this tree.
          </Typography>
          <FormControl fullWidth size="small">
            <InputLabel id="crosswalk-selector-label">Crosswalk</InputLabel>
            <Select
              labelId="crosswalk-selector-label"
              value={currentMappingSet?.id ?? ''}
              label="Crosswalk"
              onChange={(e) => handleChange(e.target.value as number | '')}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {allCrosswalks?.map((c: CrosswalkMappingSetType) => (
                <MenuItem key={c.id} value={c.id}>
                  {c.name} (ID: {c.id})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </CardContent>
    </Card>
  )
}
